<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | HEW Reports</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Health Extension Worker Reports and Analytics" name="description" />
    <meta content="CBHI System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Reports & Analytics</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">HEW</a></li>
                    <li class="breadcrumb-item active">Reports</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Alerts -->
          <div v-if="alert.success" class="alert alert-success" role="alert">
            {{message}}
          </div>
          <div v-if="alert.info" class="alert alert-primary" role="alert">
            {{message}}
          </div>
          <div v-if="alert.failed" class="alert alert-danger" role="alert">
            {{message}}
          </div>

          <!-- Report Period Selector -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-3">
                      <label class="form-label">Report Period</label>
                      <select v-model="selectedPeriod" @change="loadReports" class="form-select">
                        <option value="today">Today</option>
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                        <option value="year">This Year</option>
                        <option value="custom">Custom Range</option>
                      </select>
                    </div>

                    <div v-if="selectedPeriod === 'custom'" class="col-md-3">
                      <label class="form-label">Start Date</label>
                      <input v-model="customRange.startDate" type="date" class="form-control"
                             @change="loadReports">
                    </div>

                    <div v-if="selectedPeriod === 'custom'" class="col-md-3">
                      <label class="form-label">End Date</label>
                      <input v-model="customRange.endDate" type="date" class="form-control"
                             @change="loadReports">
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">&nbsp;</label>
                      <div>
                        <button @click="generateMonthlyReport" class="btn btn-primary me-2">
                          <i class="bx bx-file-pdf"></i> Monthly Report
                        </button>
                        <button @click="exportData" class="btn btn-success">
                          <i class="bx bx-download"></i> Export
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Service Delivery Statistics -->
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Visits</p>
                      <h5 class="mb-0">{{ statistics.total_visits || 0 }}</h5>
                      <p class="text-success mb-0 mt-1">
                        <small>{{ statistics.households_visited || 0 }} households</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-home-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Immunizations</p>
                      <h5 class="mb-0">{{ statistics.vaccinations_given || 0 }}</h5>
                      <p class="text-muted mb-0 mt-1">
                        <small>{{ statistics.children_vaccinated || 0 }} children</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-injection"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">ANC Visits</p>
                      <h5 class="mb-0">{{ statistics.anc_visits || 0 }}</h5>
                      <p class="text-muted mb-0 mt-1">
                        <small>{{ statistics.pregnant_women || 0 }} women</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-female"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Referrals Made</p>
                      <h5 class="mb-0">{{ statistics.referrals_made || 0 }}</h5>
                      <p class="text-muted mb-0 mt-1">
                        <small>{{ statistics.referrals_completed || 0 }} completed</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="bx bx-transfer"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Charts Row -->
          <div class="row">
            <!-- Service Breakdown Chart -->
            <div class="col-lg-6">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Service Delivery Breakdown</h5>
                </div>
                <div class="card-body">
                  <canvas id="serviceChart" height="300"></canvas>
                </div>
              </div>
            </div>

            <!-- Coverage Progress -->
            <div class="col-lg-6">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Household Coverage Progress</h5>
                </div>
                <div class="card-body">
                  <div class="mb-4">
                    <h4 class="text-center mb-3">{{ getCoveragePercentage() }}%</h4>
                    <div class="progress" style="height: 30px;">
                      <div class="progress-bar bg-success" role="progressbar"
                           :style="{width: getCoveragePercentage() + '%'}"
                           :aria-valuenow="getCoveragePercentage()"
                           aria-valuemin="0" aria-valuemax="100">
                        {{ statistics.households_visited || 0 }} / {{ statistics.total_households || 0 }}
                      </div>
                    </div>
                  </div>

                  <!-- Coverage Details -->
                  <div class="table-responsive">
                    <table class="table table-sm">
                      <tbody>
                      <tr>
                        <td>Total Households</td>
                        <td class="text-end fw-bold">{{ statistics.total_households || 0 }}</td>
                      </tr>
                      <tr>
                        <td>Visited This Period</td>
                        <td class="text-end fw-bold text-success">{{ statistics.households_visited || 0 }}</td>
                      </tr>
                      <tr>
                        <td>Not Yet Visited</td>
                        <td class="text-end fw-bold text-danger">
                          {{ (statistics.total_households || 0) - (statistics.households_visited || 0) }}
                        </td>
                      </tr>
                      <tr>
                        <td>Average Visit Duration</td>
                        <td class="text-end fw-bold">{{ statistics.avg_duration || 0 }} min</td>
                      </tr>
                      <tr>
                        <td>Active Days</td>
                        <td class="text-end fw-bold">{{ statistics.active_days || 0 }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Detailed Reports Tabs -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <ul class="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" data-bs-toggle="tab" href="#immunizations" role="tab">
                        <span class="d-block d-sm-none"><i class="bx bx-injection"></i></span>
                        <span class="d-none d-sm-block">Immunizations</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-bs-toggle="tab" href="#maternal" role="tab">
                        <span class="d-block d-sm-none"><i class="bx bx-female"></i></span>
                        <span class="d-none d-sm-block">Maternal Health</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-bs-toggle="tab" href="#diseases" role="tab">
                        <span class="d-block d-sm-none"><i class="bx bx-plus-medical"></i></span>
                        <span class="d-none d-sm-block">Disease Surveillance</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-bs-toggle="tab" href="#education" role="tab">
                        <span class="d-block d-sm-none"><i class="bx bx-book"></i></span>
                        <span class="d-none d-sm-block">Health Education</span>
                      </a>
                    </li>
                  </ul>

                  <div class="tab-content p-3 text-muted">
                    <!-- Immunizations Tab -->
                    <div class="tab-pane active" id="immunizations" role="tabpanel">
                      <h5 class="mb-3">Immunization Summary</h5>
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th>Vaccine</th>
                            <th class="text-center">Doses Given</th>
                            <th class="text-center">Children Vaccinated</th>
                            <th class="text-center">Coverage Rate</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="vaccine in immunizationData" :key="vaccine.vaccine_name">
                            <td>{{ vaccine.vaccine_name }}</td>
                            <td class="text-center">{{ vaccine.doses_given }}</td>
                            <td class="text-center">{{ vaccine.children_vaccinated }}</td>
                            <td class="text-center">
                                <span class="badge"
                                      :class="vaccine.coverage_rate >= 80 ? 'bg-success' : 'bg-warning'">
                                  {{ vaccine.coverage_rate }}%
                                </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Maternal Health Tab -->
                    <div class="tab-pane" id="maternal" role="tabpanel">
                      <h5 class="mb-3">Maternal Health Services</h5>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="table-responsive">
                            <table class="table table-sm">
                              <tbody>
                              <tr>
                                <td>Total ANC Visits</td>
                                <td class="text-end fw-bold">{{ maternalData.anc_visits || 0 }}</td>
                              </tr>
                              <tr>
                                <td>First ANC Visits</td>
                                <td class="text-end fw-bold">{{ maternalData.first_anc || 0 }}</td>
                              </tr>
                              <tr>
                                <td>ANC 4+ Coverage</td>
                                <td class="text-end fw-bold">{{ maternalData.anc4_plus || 0 }}</td>
                              </tr>
                              <tr>
                                <td>High Risk Pregnancies</td>
                                <td class="text-end fw-bold text-danger">{{ maternalData.high_risk || 0 }}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <canvas id="ancChart" height="200"></canvas>
                        </div>
                      </div>
                    </div>

                    <!-- Disease Surveillance Tab -->
                    <div class="tab-pane" id="diseases" role="tabpanel">
                      <h5 class="mb-3">Disease Cases Reported</h5>
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th>Disease</th>
                            <th class="text-center">Cases</th>
                            <th class="text-center">Affected Households</th>
                            <th class="text-center">Severe Cases</th>
                            <th class="text-center">Reported to Woreda</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="disease in diseaseData" :key="disease.disease_type">
                            <td>{{ disease.disease_type }}</td>
                            <td class="text-center">{{ disease.case_count }}</td>
                            <td class="text-center">{{ disease.affected_households }}</td>
                            <td class="text-center">
                                <span v-if="disease.severe_cases > 0" class="text-danger fw-bold">
                                  {{ disease.severe_cases }}
                                </span>
                              <span v-else>0</span>
                            </td>
                            <td class="text-center">
                                <span v-if="disease.reported_to_woreda > 0" class="badge bg-success">
                                  {{ disease.reported_to_woreda }}
                                </span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Health Education Tab -->
                    <div class="tab-pane" id="education" role="tabpanel">
                      <h5 class="mb-3">Health Education Sessions</h5>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="card bg-primary text-white">
                            <div class="card-body">
                              <h4 class="mb-0">{{ educationData.sessions_conducted || 0 }}</h4>
                              <p class="mb-0">Sessions Conducted</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card bg-success text-white">
                            <div class="card-body">
                              <h4 class="mb-0">{{ educationData.total_attendees || 0 }}</h4>
                              <p class="mb-0">Total Attendees</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card bg-info text-white">
                            <div class="card-body">
                              <h4 class="mb-0">{{ educationData.topics_covered || 0 }}</h4>
                              <p class="mb-0">Topics Covered</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <h6 class="mt-4">Topics Distribution</h6>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <tbody>
                          <tr v-for="topic in educationTopics" :key="topic.topic">
                            <td>{{ topic.topic }}</td>
                            <td class="text-end">{{ topic.sessions }} sessions</td>
                            <td class="text-end">{{ topic.attendees }} attendees</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Performance Metrics -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Performance Metrics</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h6>Target Achievement</h6>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                          <tr>
                            <th>Metric</th>
                            <th class="text-center">Target</th>
                            <th class="text-center">Achieved</th>
                            <th class="text-center">%</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="metric in performanceMetrics" :key="metric.name">
                            <td>{{ metric.name }}</td>
                            <td class="text-center">{{ metric.target }}</td>
                            <td class="text-center">{{ metric.achieved }}</td>
                            <td class="text-center">
                                <span class="badge"
                                      :class="metric.percentage >= 80 ? 'bg-success' : 'bg-warning'">
                                  {{ metric.percentage }}%
                                </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <h6>Monthly Trend</h6>
                      <canvas id="trendChart" height="250"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© CBHI</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Ministry of Health - Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "HEWReports",
  components: {
    NavigationBar
  },
  data() {
    return {
      // Loading states
      loading: false,

      // Report period
      selectedPeriod: 'month',
      customRange: {
        startDate: '',
        endDate: ''
      },

      // Statistics
      statistics: {},

      // Report data
      immunizationData: [],
      maternalData: {},
      diseaseData: [],
      educationData: {},
      educationTopics: [],
      performanceMetrics: [],

      // Charts
      charts: {
        service: null,
        anc: null,
        trend: null
      },

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  mounted() {

    this.loadReports();
  },

  methods: {
    checkAuth() {
      const token = localStorage.getItem("authToken");
      const userRole = sessionStorage.getItem("userRoleId");

      if (!token) {
        router.push('/login');
        return;
      }

      // Check if user is HEW (role_id = 38)
      if (userRole !== '38') {
        this.showAlert('failed', 'Access denied. HEW role required.');
        router.push('/dashboard');
      }
    },

    async loadReports() {
      this.loading = true;

      const data = {
        "function": "getServiceStatistics",
        "period": this.selectedPeriod,
        "startDate": this.customRange.startDate,
        "endDate": this.customRange.endDate
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.statistics = res.data.data.coverageStats || {};
          this.processServiceData(res.data.data.serviceStats || []);

          // Load additional report data
          await this.loadDetailedReports();

          // Update charts
          this.$nextTick(() => {
            this.renderCharts();
          });
        } else {
          this.showAlert('failed', res.data.message || 'Failed to load reports');
        }
      } catch (e) {
        console.error("Failed to load reports:", e);
        this.showAlert('failed', 'Failed to load report data');
      } finally {
        this.loading = false;
      }
    },

    async loadDetailedReports() {
      try {
        // Generate report data
        const reportData = {
          "function": "generateHEWReport",
          "reportType": this.selectedPeriod === 'month' ? 'monthly' : 'custom',
          "month": new Date().getMonth() + 1,
          "year": new Date().getFullYear()
        };

        const res = await executeJson(reportData, authUrl);

        if (res.data.success) {
          const report = res.data.data.reportData;

          // Process immunization data
          this.immunizationData = report.immunizations || [];

          // Process maternal data
          this.maternalData = report.maternal || {};

          // Process disease data
          this.diseaseData = report.diseases || [];

          // Process education data
          this.educationData = report.education || {};

          // Calculate performance metrics
          this.calculatePerformanceMetrics(report);
        }
      } catch (e) {
        console.error("Failed to load detailed reports:", e);
      }
    },

    processServiceData(serviceStats) {
      // Group service statistics for charts
      this.serviceChartData = serviceStats.reduce((acc, service) => {
        acc.labels.push(service.service_type);
        acc.data.push(service.count);
        return acc;
      }, { labels: [], data: [] });
    },

    calculatePerformanceMetrics(report) {
      // Calculate performance against targets
      const targets = {
        'Household Visits': { target: 100, achieved: report.visits?.households_visited || 0 },
        'Immunizations': { target: 50, achieved: report.immunizations?.length || 0 },
        'ANC Visits': { target: 30, achieved: report.maternal?.anc_visits || 0 },
        'Health Education': { target: 10, achieved: report.education?.sessions_conducted || 0 }
      };

      this.performanceMetrics = Object.entries(targets).map(([name, data]) => ({
        name,
        target: data.target,
        achieved: data.achieved,
        percentage: Math.round((data.achieved / data.target) * 100)
      }));
    },

    renderCharts() {
      // Destroy existing charts
      Object.values(this.charts).forEach(chart => {
        if (chart) chart.destroy();
      });

      // Service Delivery Chart
      const serviceCtx = document.getElementById('serviceChart');
      if (serviceCtx && this.serviceChartData) {
        this.charts.service = new Chart(serviceCtx, {
          type: 'doughnut',
          data: {
            labels: this.serviceChartData.labels,
            datasets: [{
              data: this.serviceChartData.data,
              backgroundColor: [
                '#556ee6',
                '#34c38f',
                '#f1b44c',
                '#f46a6a',
                '#50a5f1',
                '#e83e8c'
              ]
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              position: 'bottom'
            }
          }
        });
      }

      // ANC Visit Chart
      const ancCtx = document.getElementById('ancChart');
      if (ancCtx) {
        this.charts.anc = new Chart(ancCtx, {
          type: 'bar',
          data: {
            labels: ['1st Visit', '2nd Visit', '3rd Visit', '4th+ Visit'],
            datasets: [{
              label: 'ANC Visits',
              data: [
                this.maternalData.first_anc || 0,
                this.maternalData.second_anc || 0,
                this.maternalData.third_anc || 0,
                this.maternalData.anc4_plus || 0
              ],
              backgroundColor: '#f1b44c'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
      }

      // Trend Chart
      const trendCtx = document.getElementById('trendChart');
      if (trendCtx) {
        this.charts.trend = new Chart(trendCtx, {
          type: 'line',
          data: {
            labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
            datasets: [{
              label: 'Household Visits',
              data: [22, 28, 31, 25],
              borderColor: '#556ee6',
              tension: 0.4
            }, {
              label: 'Services Provided',
              data: [45, 52, 58, 48],
              borderColor: '#34c38f',
              tension: 0.4
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
      }
    },

    async generateMonthlyReport() {
      this.loading = true;

      const data = {
        "function": "generateHEWReport",
        "reportType": "monthly",
        "month": new Date().getMonth() + 1,
        "year": new Date().getFullYear()
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.showAlert('success', 'Monthly report generated successfully');
          // You can add PDF generation logic here
        } else {
          this.showAlert('failed', res.data.message || 'Failed to generate report');
        }
      } catch (e) {
        console.error("Failed to generate report:", e);
        this.showAlert('failed', 'Failed to generate monthly report');
      } finally {
        this.loading = false;
      }
    },

    exportData() {
      // Export functionality
      this.showAlert('info', 'Export feature coming soon');
    },

    getCoveragePercentage() {
      if (!this.statistics.total_households || this.statistics.total_households === 0) return 0;
      const visited = this.statistics.households_visited || 0;
      const total = this.statistics.total_households;
      return Math.round((visited / total) * 100);
    },

    // Alert methods
    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    }
  },

  beforeDestroy() {
    // Clean up charts
    Object.values(this.charts).forEach(chart => {
      if (chart) chart.destroy();
    });
  }
};
</script>

<style scoped>
.nav-tabs-custom .nav-item .nav-link {
  color: #495057;
}

.nav-tabs-custom .nav-item .nav-link.active {
  color: #556ee6;
}

.progress {
  background-color: #e9ecef;
}

canvas {
  max-height: 300px;
}
</style>